var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14.14","cy":"14.14","r":"7.89","fill":"none","stroke":"#282828","strokeMiterlimit":"10","strokeWidth":"2.5px","key":0}),React.createElement("path",{"strokeLinecap":"round","fill":"none","stroke":"#282828","strokeMiterlimit":"10","strokeWidth":"2.5px","d":"m19.93 19.93 5.83 5.83","key":1})]);
}

Search.defaultProps = {"aria-hidden":"true","className":"search-icon","viewBox":"0 0 32 32"};

module.exports = Search;

Search.default = Search;
